import * as React from 'react';
import { Menu, MenuItem } from '@progress/kendo-react-layout';
import { inject, observer } from 'mobx-react';
import { Popup } from '@progress/kendo-react-popup';
import { observable, makeObservable } from 'mobx';

@inject(i => ({
	rootStore: i.rootStore,
}))
@observer
class DropdownMenu extends React.Component {
	rootStore = null;
	@observable menuShown = false;

	constructor(props) {
        super(props);
        makeObservable(this);
        this.rootStore = this.props.rootStore;
    }

	handleContextMenu = e => {
		e.preventDefault();
		this.offSet = { left: e.clientX, top: e.clientY };
		this.menuShown = true;
	};

	componentDidMount() {
		document.addEventListener('click', event => {
			if (this.menuShown) this.menuShown = false;
		});
		document.addEventListener('contextmenu', e => {
			if (this.menuShown && this.props.data != e.target.getAttribute('idx')) this.menuShown = false;
		});
	}

	itemSelected = e => {
		switch (e.item.data.action) {
			case 'hyperlink':
				this.redirect(e.item.data.url);
				break;
			case 'internal-redirection': {
				this.redirectRouted(e.item.data.redirectRoute, e.item.data.redirectId);
				break;
			}
			default:
			// ignore
		}
	};

	render() {
		return (
			<div>
				<a
					href={this.props.url}
					rel="noopener noreferrer"
					target="_blank"
					onContextMenu={this.handleContextMenu}
					idx={this.props.data}
				>
					{this.props.data}
				</a>
				<Popup show={this.menuShown} offset={this.offSet}>
					<Menu vertical={true} style={{ display: 'inline-block' }} onSelect={this.itemSelected}>
						{this.props.routes.map(item => {
							return this.renderItem(item, this.props.productId);
						})}
					</Menu>
				</Popup>
			</div>
		);
	}

	redirect(url) {
		window.open(url, '_blank');
	}

	redirectRouted(route, id) {
		this.rootStore.routerStore.goTo(route, { id: id });
	}

	renderItem(item) {
		switch (item.action) {
			case 'hyperlink': {
				return (
					<MenuItem text={item.text} key={item.itemIndex} data={item} cssStyle={{ color: 'rgb(43,43,43)' }}></MenuItem>
				);
				break;
			}
			case 'internal-redirection': {
				return (
					<MenuItem text={item.text} key={item.itemIndex} data={item} cssStyle={{ color: 'rgb(43,43,43)' }}></MenuItem>
				);
				break;
				a;
			}
			default:
			// ignore
		}
	}
}

export default DropdownMenu;
